// import { enableProdMode } from '@angular/core';
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// import { environment } from './environments/environment';

// if (environment.production) {
//   enableProdMode();
// }
// enableProdMode();
// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));


import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import { ErrorInterceptor } from './app/core/helpers/error.interceptor';
import { AuthInterceptor } from './app/core/helpers/auth.interceptor';
import * as Sentry from '@sentry/angular';

if (environment.env !== "local") {

  // enableProdMode();
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    release: `${environment.env ?? ''}`,

    // Replay (newer SDKs often recommend the integration helper)
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
      }),
    ],

    ignoreErrors: ['ResizeObserver loop completed with undelivered notifications.'],

    // Performance Monitoring
    tracesSampleRate: 0, // same as your config

    // Session Replay sampling
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: EventInterceptor, multi: true }, //Call to handle success realated stuff
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ...appConfig.providers
  ]
})
.catch((err) => console.error('Error during bootstrapping the application:', err));

